import { useEffect } from "react";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "8px",
  },
  a: {
    color: "#fff",
    background: "#00000099",
    textDecoration: "none",
    fontSize: ".75em",
    padding: ".5em",
    cursor: "pointer",
    borderRadius: ".25em",
  },
  img: {
    verticalAlign: "middle",
  },
  rootTheme2: {
    position: "absolute",
    right: 0,
    bottom: 0,
  },
  aTheme2: {
    background: "#00000014",
    color: "#333",
    textDecoration: "none",
    cursor: "pointer",
  },
  size: {
    fontSize: ".75em",
    padding: ".75em",
  },
  sizeSmall: {
    fontSize: "10px",
    padding: "2px 4px",
  },
  center: {
    right: "50%",
    transform: "translateX(50%)",
  },
}));

const PoweredBy = (props) => {
  const classes = useStyles();
  useEffect(() => {
    // window.addEventListener("message", (event) => {
    //   console.log(event.data);
    // });
  }, []);
  const isRecommender = props.widget === "recommender";
  const isLogo = !props.planId || props.planId <= 1;
  return (
    <Box
      display="flex"
      justifyContent="center"
      className={
        isRecommender || props.align === "center"
          ? classes.root
          : `${classes.rootTheme2} ${props.center ? classes.center : ""}`
      }
    >
      {isLogo && (
        <a
          className={isRecommender ? classes.a : `${classes.aTheme2} ${classes.sizeSmall}`}
          href={`https://ezca.asia?utm_source=widget-${props.widget
            }&utm_medium=${props.dh ?? "link"}&utm_campaign=referral`}
          target="_blank"
          rel="noreferrer"
          style={{ color: props.color ?? "#333" }}
        >
          <img
            className={classes.img}
            src="/static/images/icons/power.svg"
            alt=""
          />{" "}
          by{" "}
          <span>
            <strong>ezca.asia</strong>
          </span>
        </a>
      )}
    </Box>
  );
};
export default PoweredBy;
